<script>
import appConfig from "@/app.config";

import { notificationMethods } from "@/state/helpers";

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    }
  },
  created() {
    if (localStorage.getItem('jwt') != null){
      this.axios.get(process.env.VUE_APP_BACKEND + '/api/usuarios/permisos')
          .then(response => {
            //console.log(response);
            localStorage.setItem('permissions',JSON.stringify(response.data.permissions));
            localStorage.setItem('menu',JSON.stringify(response.data.menu));
          })
          .catch( ()=> {
            this.$swal('error','error','error')
          })
          .finally(()=>
          {
            //this.isLoading=false;
          });
    }

  },
  mounted() {


  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    }
  },
  methods: {
    clearNotification: notificationMethods.clear
  }
};
</script>

<template>
  <div id="app">
    <RouterView />
  </div>
</template>
